'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { Suspense } from 'react';

import { useAuth } from '@flipster/features/src/shared/auth/state';
import { SymbolContext } from '@flipster/features/src/shared/symbol/bunja';
import { useBreakpoint } from '@flipster/react/misc/responsive';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import PerpetualOrderForm from '@web/app/[locale]/(web)/trade/_misc/order-form/perpetual';
import SpotOrderForm from '@web/app/[locale]/(web)/trade/_misc/order-form/spot';
import { TradFiOrderFormBanner } from '@web/app/[locale]/(web)/trade/_misc/order-form/tradfi-promo-banner';
import { tradeSymbolBunja } from '@web/app/[locale]/(web)/trade/_misc/symbol';

export const OrderForm = () => {
  const { symbol, symbolInfoAtom } = useBunja(tradeSymbolBunja);
  const symbolInfo = useAtomValue(symbolInfoAtom);

  const { isLoggedIn, isValidKyc } = useAuth();
  const { isMobile } = useBreakpoint();

  const isShowKycAlert = isLoggedIn && !isValidKyc;

  return (
    <section
      className={stack({
        gridArea: 'order-form',
        display: { base: 'none', tablet: 'flex' },
        pos: 'sticky',
        top: 'calc({sizes.navigationHeight} + var(--grid-space))',
        h: {
          tablet: 'calc({sizes.minHeightWithoutNavigation} - (var(--grid-space) * 2) - var(--fomo-banner-height))',
        }, // fomo-banner 가 더 있을 경우
        overflowY: 'auto',
        bgColor: 'background.default.level-0',
        rounded: 'var(--grid-rounded)',
        '&:last-child': {
          h: { tablet: 'calc({sizes.minHeightWithoutNavigation} - (var(--grid-space) * 2))' },
        },
      })}
    >
      <div
        className={css(
          {
            pos: 'relative',
            h: '100%',
            minH: 'max-content',
          },
          (!isLoggedIn || isShowKycAlert) && {
            _after: {
              content: '""',
              pos: 'absolute',
              inset: 0,
              backgroundColor: 'background.interaction.dim',
              zIndex: 50,
            },
          },
        )}
      >
        {!isMobile && (
          <SymbolContext value={symbol}>
            <Suspense>
              {symbolInfo?.isFutures && <PerpetualOrderForm />}
              {symbolInfo?.isSpot && <SpotOrderForm />}
            </Suspense>
            <TradFiOrderFormBanner />
          </SymbolContext>
        )}
      </div>
    </section>
  );
};
